import { render, staticRenderFns } from "./NotificationAccountWillBeDeleted.vue?vue&type=template&id=43efbb60&scoped=true&lang=pug&"
import script from "./NotificationAccountWillBeDeleted.vue?vue&type=script&lang=js&"
export * from "./NotificationAccountWillBeDeleted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43efbb60",
  null
  
)

export default component.exports